module.exports = __webpack_public_path__ + "img/gold_symbol_1.42016b6b.png";